import { connect } from 'react-redux'
import { actions, selectors, getAttributes, launcherLaunchEve } from '../../../../imports'
import { getUserProfile, getUserAccessToken } from '../../../../data'
import LaunchFrame from './component'

export function mapStateToProps(state, ownProps) {
    const server = selectors.getActiveServer(state)
    const serverId = server.serverId
    const { userId } = ownProps
    const profile = getUserProfile(state, serverId, userId)
    const accessToken = getUserAccessToken(state, serverId, userId)
    const progress = selectors.getActiveLaunchProgress(state, userId).percent
    const attributes = getAttributes(selectors.getLocale(state))

    // Retrieve the hostname from the server object
    const host = server.sso.url

    // Prepare the SSO link
    const clientTokenUrl = attributes.clientTokenUrl
        .replace('{host}', host)
        .replace('{accessToken}', accessToken)

    return {
        userId,
        progress,
        clientTokenUrl,
        accessToken,
        launchEve: token => launcherLaunchEve(serverId, userId, profile, token),
        serverId,
        profile,
    }
}

const setLaunchProgress = (userId, progress) => (dispatch, getState) => {
    const serverId = selectors.getActiveServerId(getState())
    dispatch(actions.setClientLaunchProgress(serverId, userId, progress))
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        setClientLaunchProgress: (progress) => {
            dispatch(setLaunchProgress(ownProps.userId, progress))
        },
        setClientLauncherToken: (serverId, userId, profile, token) => {
            dispatch(actions.setClientLauncherToken(serverId, userId, profile, token))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LaunchFrame)



// WEBPACK FOOTER //
// ./src/features/Users/components/UserList/components/LaunchFrame/index.js